module.exports = __webpack_public_path__ + "static/img/2.50daee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 36